// Modal
export const MODAL_ROOT_Z_INDEX = 999;
export const MODAL_ROOT_ID = 'modal-root';


// Sidebar Mobile
export const SIDEBAR_MOBILE_ROOT_Z_INDEX = MODAL_ROOT_Z_INDEX - 1;
export const SIDEBAR_MOBILE_ROOT_ID = 'sidebar-mobile-root';
